export default "__VITE_ASSET__BxvJ8Oon__"